export default {
  async setUser({ commit, state }, item) {
    const response = await axios.get(`/api/user?include=headshot_image`);

    commit('setUser', response.data);
  },
  async setScale({ commit, state }, value) {
    commit('setScale', value);
  },
  async setScreenSize({ commit, state }, size) {
    commit('setScreenSize', size);
  },
  async setEducationResults({ commit, state }, value) {
    commit('setEducationResults', value);
  },

  async setPendingReviews({ commit, state }, value) {
    const response = await axios.get(`/api/reviews`);

    commit('setPendingReviews', response.data);
  },
};
